import { render, staticRenderFns } from "./Cast.vue?vue&type=template&id=2ff40030&scoped=true&"
import script from "./Cast.vue?vue&type=script&lang=js&"
export * from "./Cast.vue?vue&type=script&lang=js&"
import style0 from "./Cast.vue?vue&type=style&index=0&id=2ff40030&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff40030",
  null
  
)

export default component.exports